import { useTranslation as useTranslationI18Next, Trans as TransI18n } from 'react-i18next';

import { useSiteContext } from '@zooplus/commons-lang';

export const useTranslation = () => {
  const {
    site: { realm },
  } = useSiteContext();
  return useTranslationI18Next(`loyalty-management/translations/${realm}`);
};

export const Trans: typeof TransI18n = (props) => {
  const { t } = useTranslation();
  return <TransI18n t={t} {...props} />;
};
